import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { HiOutlineChat } from 'react-icons/hi';
import axios from 'axios'; // Added axios import

const CourseChat = () => {
  const { courseId } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]); // Added messages state

  useEffect(() => {
    let isSubscribed = true;

    const fetchMessages = async () => {
      try {
        const response = await axios.get(`/api/courses/${courseId}/chat`);
        if (isSubscribed) {
          setMessages(response.data);
        }
      } catch (error) {
        console.error('Error fetching messages:', error);
      }
    };

    fetchMessages();

    return () => {
      isSubscribed = false;
    };
  }, [courseId]);

  if (loading) {
    return (
      <div className="p-6">
        <div className="bg-white dark:bg-gray-800 shadow-sm rounded-lg">
          <div className="p-6 text-center">جاري التحميل...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="bg-white dark:bg-gray-800 shadow-sm rounded-t-lg rounded-b-lg">
        {/* رأس البطاقة الرئيسية */}
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
          <h1 className="text-lg font-medium text-gray-900 dark:text-white">محادثات الكورس</h1>
          <HiOutlineChat className="h-6 w-6 text-blue-600 hover:text-blue-700 dark:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200" />
        </div>

        {/* محتوى البطاقة */}
        <div className="p-6">
          {/* هنا هنضيف محتوى المحادثات في الخطوة التالية */}
          <div className="text-center text-gray-500 dark:text-gray-400">
            قريباً - محادثات الكورس
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseChat;
